module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ei0Wd"))).then(() => parcelRequire('1iHdE'));